import { Component, Input, OnInit } from '@angular/core';
import { isEmpty } from 'lodash';

import { MapDataLocationMarker } from '@finder/shared/components/map/map/map.interface';
import { DebugService } from '@finder/features/debug/services/debug-service/debug.service';

@Component({
    selector: 'finder-map-card',
    templateUrl: './map-card.component.html',
    styleUrls: ['./map-card.component.scss'],
})
export class MapCardComponent implements OnInit {
    hasMedia = false;
    debug = false;

    /**
     * New modules are added here
     * src/app/shared/components/map/map.module.ts
     * New inputs are added here
     * src/app/shared/services/map-card/map-card.service.ts
     */
    @Input() marker: MapDataLocationMarker;

    constructor(
        private debugService: DebugService,
    ) { }

    ngOnInit(): void {
        this.hasMedia = !isEmpty(this.marker?.card?.media);
        this.debug = this.debugService.isDebugEnabled();
    }

    showDebug(e) {
        // Don't link to anything
        e.preventDefault();

        // Send marker data to json editor
        this.debugService.updateEditorData({ data: { config: this.marker }, url: '#map-pin', expand: true });
    }
}
